<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
  <p *ngFor="let p of data.body">
    {{ p }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [disabled]="data.loading" (click)="cancel()">
    Cancel
  </button>
  <button
    mat-raised-button
    color="error"
    [disabled]="data.loading"
    (click)="handleConfirm()"
  >
    <span *ngIf="!data.loading">Delete</span>
    <mat-progress-spinner
      *ngIf="data.loading"
      mode="indeterminate"
      diameter="20"
    ></mat-progress-spinner>
  </button>
</mat-dialog-actions>
